import { AgGridReact } from 'ag-grid-react'
import React, { useEffect, useState } from 'react'
import { downloadLeaveAttachment } from '../../api-services/employee-services';
import './gridContainer.css'
import { RowStyle } from 'ag-grid-community';

interface LeaveReviewContainerProps {
    rowData: any[],
    handleEditEmployees?: (params: boolean) => void,
    columnDefs?: any[],
    editType?: string,
    suppressRowClickSelection?: boolean,
    stopEditingWhenCellsLoseFocus?: boolean,
    singleClickEdit?: boolean,
    onGrid?: (params: any) => void,
    rowSelection?: "single" | "multiple",
    enableRangeSelection?: true,
    onCellValueChanged?: (e: any) => void,
    pinnedBottomRowData?: any,
    rowStyle?: (params: any) => RowStyle | undefined;
    onSelectionChanged?: () => void;
    onRowValueChange?: (params: any) => void;
}

const AgGridContainer = (props: LeaveReviewContainerProps) => {
    const [rowData, setRowData] = useState<any[]>([])
    const [colDef, setColDef] = useState<any[]>([])
    // const columnDefs: any = [
    //     {
    //         headerName: "Name",
    //         field: "name",
    //         resizable: true,
    //         filter: true,
    //     },
    //     {
    //         headerName: "Leave Type",
    //         field: "leaveType",
    //         resizable: true,
    //         filter: true,
    //     },
    //     {
    //         headerName: "From Date",
    //         field: "fromDate",

    //         resizable: true,
    //         filter: true,
    //     },
    //     {
    //         headerName: "To Date",
    //         field: "toDate",

    //         resizable: true,
    //         filter: true,
    //     },
    //     {
    //         headerName: "Days",
    //         field: "noOfDays",

    //         resizable: true,
    //         filter: true,
    //     },
    //     {
    //         headerName: "Session",
    //         field: "session",

    //         resizable: true,
    //         filter: true,
    //     },
    //     {
    //         headerName: "Schedule ",
    //         field: "leavePeriod",

    //         resizable: true,
    //         filter: true,
    //     },
    //     {
    //         headerName: "Reason",
    //         field: "reasonForLeave",
    //         resizable: true,
    //         cellRenderer: (params: any) => (
    //             <CustomDetailsCellRender data={params} flag={false} />
    //         ),
    //     },
    //     {
    //         headerName: "Attachment",
    //         field: "attachment",
    //         resizable: true,
    //         filter: true,
    //         cellRenderer: (params: any) => {
    //             let content;
    //             if (params.data.attachment !== 'NA') {
    //                 const parts = params.data.attachment.split('_');
    //                 const filename = parts[parts.length - 1].trim();
    //                 const fileNames = filename;
    //                 content = (
    //                     <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
    //                         <div
    //                             style={!props.actionStatus ? { cursor: 'pointer' } : {}}
    //                             onClick={!props.actionStatus ? (e) => onDownloadAttachment(e, params.data.leaveId, filename, params.data.name) : undefined}
    //                         >{fileNames}</div>
    //                         {/* <div>
    //                             <Button
    //                                 variant='contained'
    //                                 size='small'
    //                                 style={{
    //                                     background: "var(--primaryColor)",
    //                                     color: "white"
    //                                 }}
    //                                 className='leave-review-download-button-container'
    //                                 onClick={(e) => onDownloadAttachment(e, params.data.leaveId, filename, params.data.name)}
    //                             >
    //                                 <DownloadIcon />
    //                             </Button>
    //                         </div> */}
    //                     </div>
    //                 );
    //             } else {
    //                 content = (
    //                     <div className='leave-review-field-container-no-file'>
    //                         {params.data.attachment}
    //                     </div>
    //                 );
    //             }

    //             return (
    //                 <div style={{ width: '100%' }}>
    //                     {content}
    //                 </div>
    //             );
    //         }
    //     },
    //     {
    //         headerName: "Action",
    //         field: "leaveStatus",
    //         resizable: true,
    //         filter: true,

    //         cellRenderer: (params: any) => (
    //             <>
    //                 <ApproveRejectCell value={params.data} handleEditEmployees={handleEditEmployees} flag={props.actionStatus} />
    //             </>

    //         ),
    //     },
    // ];

    useEffect(() => {
        if (props.rowData !== null && props.rowData.length > 0) {
            setRowData(props.rowData)
        } else {
            setRowData([])
        }
        if (props.columnDefs && props.columnDefs.length > 0) {
            setColDef(props.columnDefs)
        }
    }, [props])

    const handleEditEmployees = (params: boolean) => {
        if (props.handleEditEmployees) {
            props.handleEditEmployees(params)
        }
    }

    const onDownloadAttachment = (e: any, id: any, fileName: any, name: any) => {
        const filesName = `${name}_${fileName}`
        downloadLeaveAttachment(id).then((response: any) => {
            if (response?.data) {
                console.log(response)
                const linkSource = window.URL.createObjectURL(response.data);
                const downloadLink = document.createElement("a");
                downloadLink.href = linkSource;
                downloadLink.download = filesName;
                downloadLink.click();
            }
        })
    }

    const onGridReady = (params: any) => {
        if (props.onGrid)
            props.onGrid(params)
    }

    const getRowStyle = (params: any): RowStyle | undefined => {
        if (props.rowStyle)
            return props.rowStyle(params);
        // Return undefined if props.rowStyle is not provided or returns undefined
        return undefined;
    }


    return (
        <div className='grid-container'>
            <AgGridReact
                onGridReady={onGridReady}
                rowData={rowData}
                columnDefs={colDef}
                className="ag-theme-alpine"
                editType={props.editType === 'fullRow' ? 'fullRow' : undefined}
                suppressRowClickSelection={props.suppressRowClickSelection}
                stopEditingWhenCellsLoseFocus={props.stopEditingWhenCellsLoseFocus}
                singleClickEdit={props.singleClickEdit}
                rowSelection={props.rowSelection === "single" || props.rowSelection === "multiple" ? props.rowSelection : undefined}
                enableRangeSelection={props.enableRangeSelection}
                onCellValueChanged={props.onCellValueChanged}
                getRowStyle={getRowStyle}
                pinnedBottomRowData={props.pinnedBottomRowData}
                onSelectionChanged={props.onSelectionChanged}
                suppressMenuHide={true}
                onRowValueChanged={props.onRowValueChange}
            />
        </div>

    )
}

export default AgGridContainer
